<table>
  <thead>
    <ng-content select="tr[header-row]"></ng-content>
  </thead>
  <tbody>
    <ng-content select="tr"></ng-content>
  </tbody>
</table>
